import { OnDestroy, Pipe, PipeTransform } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

/**
 * Converts scalar to Observable
 *
 * Plz keep in mind that pipes with generic type params don't typecheck
 * https://github.com/angular/angular/issues/46977
 */
@Pipe({
  name: 'finToBehaviorSubject',
  pure: true,
  standalone: false,
})
export class ToBehaviorSubjectPipe<T> implements PipeTransform, OnDestroy {
  private currentValue: T;
  private behaviorSubject$: BehaviorSubject<T>;

  ngOnDestroy(): void {
    this.behaviorSubject$.complete();
  }

  transform = (a: T): BehaviorSubject<T> => {
    if (a !== this.currentValue) {
      if (!this.behaviorSubject$) {
        this.behaviorSubject$ = new BehaviorSubject<typeof a>(a);
      }
      this.currentValue = a;
      this.behaviorSubject$.next(a);
    }

    return this.behaviorSubject$;
  };
}
